import { render, staticRenderFns } from "./VersionObject.vue?vue&type=template&id=050b60ae&scoped=true&"
import script from "./VersionObject.vue?vue&type=script&lang=js&"
export * from "./VersionObject.vue?vue&type=script&lang=js&"
import style0 from "./VersionObject.vue?vue&type=style&index=0&id=050b60ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b60ae",
  null
  
)

export default component.exports